import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { Reveal, EASE } from "@/components/motion";
import { UPSELL_DIFF } from "@/lib/pricing";

const Bar = ({ label, total, pct, gold, delay }) => {
  const { eur } = useI18n();
  return (
    <div>
      <div className="flex items-baseline justify-between">
        <span className="font-display text-2xl font-bold uppercase">{label}</span>
        <span className={`font-display text-3xl font-black ${gold ? "text-[var(--gold)]" : ""}`}>{eur(total)}</span>
      </div>
      <div className="mt-3 h-3 bg-white/10">
        <motion.div initial={{ scaleX: 0 }} whileInView={{ scaleX: pct }} viewport={{ once: true }} transition={{ duration: 1.3, ease: EASE, delay }}
          className={`h-full origin-left ${gold ? "bg-[var(--gold)]" : "bg-[var(--steel-dim)]"}`} />
      </div>
    </div>
  );
};

export const Upsell = () => {
  const { t, eur } = useI18n();
  const u = t.upsell;
  return (
    <section className="grain relative overflow-hidden bg-[var(--night)] py-24 lg:py-36" data-testid="upsell-section">
      <div className="container-x relative grid gap-16 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-mono text-sm uppercase tracking-[0.2em] text-[var(--gold)]" data-testid="upsell-question">{u.eyebrow}</p>
            <h2 className="font-display mt-6 text-5xl font-black uppercase leading-[0.9] sm:text-7xl">
              <span className="block text-[var(--steel)]">{u.big[0]}</span>
              <span className="block text-[var(--gold)]" data-testid="upsell-diff">{u.big[1]}</span>
              <span className="block">{u.big[2]}</span>
            </h2>
            <p className="mt-6 max-w-xl text-[var(--steel)]">{u.text}</p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="space-y-8 border border-white/12 bg-white/[0.03] p-7 lg:col-span-5">
          <Bar label={u.two} total={25000} pct={25000 / 29700} delay={0.2} />
          <Bar label={u.three} total={29700} pct={1} gold delay={0.4} />
          <div className="flex items-center justify-between border-t border-white/10 pt-6">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--steel-dim)]">Δ</span>
            <span className="font-display text-5xl font-black text-[var(--gold)]">+{eur(UPSELL_DIFF)}</span>
          </div>
          <Link to="/commander?qty=3" data-testid="upsell-cta" className="group flex items-center justify-between bg-[var(--gold)] px-6 py-4 text-xs font-bold uppercase tracking-[0.16em] text-[var(--night)] hover:bg-[var(--gold-hi)]">
            {u.cta}<ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
